'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _littleLoader = require('little-loader');

var _littleLoader2 = _interopRequireDefault(_littleLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sdk = void 0;
var sdkLoading = false;

var trackQueue = [];
var defaultSdkCDN = 'https://jssdk.pulse.schibsted.com/autoTracker.with-engage.min.js';

var convert = function convert(params) {
    var customPulse = params.custom ? params.custom.pulse : {};

    var pulseEngageEvent = {
        clientId: params.site.toLowerCase(),
        contentId: params.content.id,
        contentType: params.type,
        category: params.content.categories[0],
        experiments: params.experiments,
        trackingFeatures: {
            articleEngage: true,
            engageOpts: {
                site: params.site,
                device: params.device,
                permalink: params.url,
                contentType: params.type,
                articleId: params.content.id,
                title: params.content.title,
                category: params.content.categories[0],
                group: params.content.group,
                published: params.content.published,
                updated: params.content.updated,
                authors: params.content.authors,
                wordCount: params.content.wordcount,
                enableOverlay: params.enableOverlay,
                shareUrl: {
                    facebook: params.url
                },
                previewUrl: {
                    http: params.url,
                    https: params.url
                }
            }
        },
        userId: params.userId,
        userIdDomain: params.userIdDomain || 'spid.no',
        object: customPulse,
        provider: {
            productTag: params.content.productTag
        }
    };

    return pulseEngageEvent;
};

exports.default = function () {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$cdn = _ref.cdn,
        cdn = _ref$cdn === undefined ? defaultSdkCDN : _ref$cdn,
        _ref$trackerId = _ref.trackerId,
        trackerId = _ref$trackerId === undefined ? 'engage' : _ref$trackerId;

    return {
        track: function track(params) {
            return new _promise2.default(function (resolve, reject) {
                if (!params) {
                    return reject(new Error('Tracking params must be specified'));
                }

                var isInitialized = sdk && !sdkLoading;
                var isUninitialized = !sdk && !sdkLoading;
                var isLoading = !sdk && sdkLoading;
                var isStalled = sdk && sdkLoading;

                if (isInitialized) {
                    params.url = window.location.href; // eslint-disable-line
                    var sdkParams = convert(params);

                    sdk.initTracking(sdkParams, true);
                } else if (isLoading) {
                    params.url = window.location.href; // eslint-disable-line
                    var _sdkParams = convert(params);

                    trackQueue.push(_sdkParams);
                } else if (isUninitialized || isStalled) {
                    var _sdkParams2 = convert(params);

                    sdkLoading = true;
                    window.pulse2opt = _sdkParams2; // eslint-disable-line

                    (0, _littleLoader2.default)(cdn, function (err) {
                        if (err) {
                            return reject(err);
                        }

                        try {
                            if (!window.AutoTrack) {
                                // eslint-disable-line
                                sdk = true;
                                throw new Error('Stalled: failed to load Pulse+Engage SDK using CDN: ' + cdn);
                            }

                            sdk = window.AutoTrack; // eslint-disable-line

                            sdkLoading = false;
                            trackQueue.forEach(function (event) {
                                return sdk.initTracking(event, true);
                            });
                        } catch (trackErr) {
                            return reject(trackErr);
                        }

                        return resolve({
                            response: 'Pulse+Engage tracking completed.',
                            params: params,
                            trackerId: trackerId
                        });
                    });
                }

                return undefined;
            });
        }
    };
};
//# sourceMappingURL=pulse-engage.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/tracking/lib/cjs/pulse-engage.js
 ** module id = 561
 ** module chunks = 1
 **/